import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleApiErrorWithFallback } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const ProductAssociationApi = {
  getProductCatalog: (
    action: { page: number; limit: number; searchCode?: string },
    dispatch: Dispatch
  ) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    if (action.searchCode) {
      queryParams.set(EUrlParams.Search, action.searchCode);
    }
    return AxiosClient.post(`/product/v1/catalog/read?${queryParams}`, {})
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.ProductCatalogKey
        );
      });
  },

  getProductConfiguration: (
    action: { page: number; limit: number; searchCode?: string },
    dispatch: Dispatch
  ) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    if (action.searchCode) {
      queryParams.set(EUrlParams.Search, action.searchCode);
    }
    return AxiosClient.post(`/configuration/v1/read?${queryParams}`, {})
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.ProductConfigurationKey
        );
      });
  },

  getArchivedConfiguration: (
    action: { page: number; limit: number; searchCode?: string },
    dispatch: Dispatch
  ) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    if (action.searchCode) {
      queryParams.set(EUrlParams.Search, action.searchCode);
    }
    return AxiosClient.post(`/archive/v1/configuration/read?${queryParams}`, {})
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.ArchivedConfigurationKey
        );
      });
  },
};
